import { useCallback } from "react";

function useAdvanceRCS({ key = "", carrousel = null, values = {} }) {
  const getBasePath = useCallback(() => {
    return carrousel !== null ? `carrousel.${carrousel}.${key}` : key;
  }, [carrousel, key]);

  const getCurrentValues = useCallback(() => {
    return carrousel !== null
      ? values.carrousel?.[carrousel]?.[key]
      : values[key];
  }, [carrousel, key, values]);

  const basePath = getBasePath();
  const currentValues = getCurrentValues();

  return { basePath, currentValues };
}

export default useAdvanceRCS;
